import { Alert, PageHeader } from "@station/ui";
import { createFileRoute } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { TransfersBody } from "../../../features/platform/account.js";
import { useDocumentTitle } from "../../../lib/hooks.js";
import { usePermissions } from "../../../lib/session.js";

export const Route = createFileRoute("/_app/ayarlar/istasyon-devirleri")({ component: StationTransfersPage });

/**
 * İstasyon devirleri (Prompt 24): bu hesabın taraf olduğu devirler. Devreden ve devralan hesabın yetkilileri ayrı ayrı onaylar;
 * iki onaydan sonra platform ekibi devir tarihinde yürütür ve sonuç raporu iki tarafta da görünür.
 */
function StationTransfersPage(): ReactElement {
  const { t } = useTranslation();
  const allowed = usePermissions().hasAny("stations.transfer.approve", "stations.read");
  useDocumentTitle(t("menu.stationTransfers"));
  return (
    <>
      <PageHeader
        title={t("menu.stationTransfers")}
        description={t("account.transfers.description")}
        breadcrumb={[{ label: t("menu.groups.settings") }, { label: t("menu.stationTransfers") }]}
      />
      {allowed ? <TransfersBody /> : <Alert tone="info">{t("account.noPermission")}</Alert>}
    </>
  );
}
